import request from '@/utils/request'
import { AxiosResult, RoadAreaCodeListParams } from '@/typings/common'

/**
 * **************************************  **************************************
 */
// 分页云途路区代码
export function getRoadAreaList(data:RoadAreaCodeListParams) {
  return request.post<AxiosResult>('/lbu/api/roadArea/findByPage', data)
}
// 云途路区代码
export function getLbuRoadAreaSelectList(data: any) {
  return request.post<AxiosResult>('/lbu/api/roadArea/list', data)
}
